import React from 'react';
import { SiteSection, SiteSectionHeader } from '../../components/site';
import type { SolutionPremiumSections } from './types';
import { useTabPanel } from './useTabPanel';

export const SolutionUseCaseExplorer: React.FC<{
  useCases: SolutionPremiumSections['useCases'];
}> = ({ useCases }) => {
  const { active, getPanelProps, getTabProps } = useTabPanel(useCases.items);

  return (
    <SiteSection id="use-cases" className="solution-use-cases">
      <SiteSectionHeader
        eyebrow={useCases.eyebrow}
        title={useCases.title}
        subtitle={useCases.subtitle}
        align="center"
      />
      <div className="solution-use-cases__pills-wrap">
        <div className="solution-use-cases__pills" role="tablist" aria-label="Use cases">
          {useCases.items.map((item) => {
            const selected = item.id === active.id;
            return (
              <button
                key={item.id}
                type="button"
                className={`solution-use-cases__pill${selected ? ' solution-use-cases__pill--active' : ''}`}
                {...getTabProps(item, selected)}
              >
                {item.label}
              </button>
            );
          })}
        </div>
      </div>
      {useCases.items.map((item) => (
        <div
          key={item.id}
          className={`solution-use-cases__panel${item.id === active.id ? ' solution-use-cases__panel--active' : ''}`}
          {...getPanelProps(item)}
        >
          <header className="solution-use-cases__panel-head">
            <h3>{item.title}</h3>
            <p>{item.subtitle}</p>
          </header>
          <ul className="solution-use-cases__grid">
            {item.features.map((feature) => (
              <li key={feature.title} className="solution-use-cases__card">
                <h4>{feature.title}</h4>
                {feature.bullets?.length ? (
                  <ul className="solution-use-cases__card-list">
                    {feature.bullets.map((point) => (
                      <li key={point}>{point}</li>
                    ))}
                  </ul>
                ) : feature.description ? (
                  <p>{feature.description}</p>
                ) : null}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </SiteSection>
  );
};
